import { ISchedule } from '../../repositories/newbuilding-calltracking/entities/FlatTourBooking/Schedule';

export function isValidFlatTourBookingSchedule(schedule: ISchedule) {
  const { general, availableDateIntervals } = schedule;

  return general.length === 7 && !!availableDateIntervals.length;
}
